import {
    IconCardDragIndicator,
} from '../../../../../components/buttons/IconButtons';

/**
 *
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTitle: Frontend
 * @Description: A card component that can be expanded/collapsed and optionally draggable.
 *               Displays a header, body content, a switch, and a drag handle for sorting.
 * @param {Function|JSX.Element} header - Content for the card header. Can be a function receiving { expanded } or a JSX element.
 * @param {Function|JSX.Element} body - Content for the card body. Can be a function receiving { expanded } or a JSX element.
 * @param {Boolean} switchEnabled - Initial state of the switch (optional, default: true)
 * @param {Function} onSwitchChange - Callback when switch value changes, receives the new boolean value.
 * @param {String|Number} itemText - Text or number displayed next to the drag handle (optional, default: '2')
 * @param {Object} dragHandleProps - Props passed from a drag-and-drop library (e.g., DnD Kit) to make the drag handle functional.
 * @param {string} [className=""] - Optional custom CSS classes for the card root container.
 * @param {string} [classNameIconContainer=""] - Optional CSS classes for the icon container.
 * @returns {JSX.Element}
 */
const DraggableCard = ({
    body,
    footer,
    item = '1',
    dragHandleProps,
    backgroundColor,
    className = '',
    classNameIconContainer = ''

}) => {

    return (
        <div className={`${backgroundColor} ${className} draggable-card shadow-none d-flex  align-items-stretch border-radius-right-8px`}>
            <div className={`d-flex py-12px align-items-center justify-content-center
             card-accent-400-50 border-radius-8px-0px ${classNameIconContainer}`}
                 {...dragHandleProps}
            >
                <IconCardDragIndicator className={'icon-color-accent-550'} />
            </div>
            <div className={`d-flex align-items-center w-100`}>
                <div className='d-flex align-items-center justify-content-center ml-3 ibl-font-w-600'>{item}</div>
                <div className='vertical-separator my-3' />
                <div className={`w-100 ${backgroundColor}`}>
                    <div className='flex-grow-1'>
                        {typeof body === 'function' ? body() : body}
                    </div>
                    {footer}
                </div>
            </div>
        </div>
    );
};

export default DraggableCard;
